/* 🤖 this file was generated by svg-to-ts */
export const matIconNorthWest: {
  name: 'north-west';
  data: string;
} = {
  name: 'north-west',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M5 15h2V8.41L18.59 20 20 18.59 8.41 7H15V5H5v10z"/></svg>`
};
